 window.CKEDITOR_BASEPATH = '/assets/ckeditor/';
 window.BACKEND_URL = '/TasyAppServer';
 window.AGENT_MODULE_SSO_BACKEND_URL = 'http://localhost:4565/agent-module-sso';
